import { NewInternationalShippingParamsInterface } from '../../deliveryMethodsSlice';

export const initialValues: NewInternationalShippingParamsInterface = {
  id: '',
  name: '',
  cartValueMax: '',
  cartWeightMin: '',
  cartValueMin: '',
  cartWeightMax: '',
  deliveryTimeMin: '',
  deliveryTimeMax: '',
  deliveryCost: 'with-cost',
  cost: '',
  allowedForFreeShipping: false,
};
